module.exports = __webpack_public_path__ + "img/du.5dbf05df.png";